import { Row, Text } from "@amzn/meridian";
import { ConversationSummary } from "../types";

interface ConversationDetailSummaryProps {
  summary: ConversationSummary;
}
const ConversationDetailSummary = ({
  summary,
}: ConversationDetailSummaryProps) => {
  // summary values shown in the header
  const headerItems = [
    { label: "User", value: summary?.userAlias },
    { label: "Turn Count", value: summary?.turnCount },
    { label: "Favorite Count", value: summary?.favoriteCount },
    { label: "# Vote Up", value: summary?.voteUp },
    { label: "# Vote Down", value: summary?.voteDown },
    { label: "Saige Question Count", value: summary?.saigeQuestionCount },
    { label: "Saige No Answer Count", value: summary?.saigeNoAnswerCount },
    { label: "Exception Count", value: summary?.exceptionCount },
    { label: "Duration in Minutes", value: summary?.durationInMinutes },
  ];

  return (
    <Row type="fill" spacingInset="300">
      {headerItems.map(({ label, value }) => (
        <Row spacing={"300"}>
          <Text type="h100">{label}:</Text>
          <Text>{value}</Text>
        </Row>
      ))}
    </Row>
  );
};

export default ConversationDetailSummary;
